"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genRandomHexString = void 0;
const times_1 = __importDefault(require("lodash/times"));
const genRandomHexString = (size) => (0, times_1.default)(size, () => Math.floor(Math.random() * 16).toString(16)).join('');
exports.genRandomHexString = genRandomHexString;
//# sourceMappingURL=rand.js.map